import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { NotifierModule, NotifierService } from 'angular-notifier';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';

import { firstValueFrom, lastValueFrom } from 'rxjs';

import { InsuranceAcceptanceService } from 'src/app/services/desgravamen/insurance-acceptance.service';
import { InsuranceConsultService } from 'src/app/services/desgravamen/insurance-consult.service';
import { CryptoJsService } from 'src/app/core/services/crypto-js.service';
import { ToastsContainer } from 'src/theme/component/toast/toast-container.component';
import { DeviceInfo, DeviceInfoService } from 'src/app/core/services/device-info';
import { UtilsService } from '../../core/services/utils.service';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { AffiliationLockService } from 'src/app/core/services/affiliation-lock.service';
import { InsuranceConsult } from 'src/app/models/desgravamen/insurance-consult';
import { FeatherModule } from 'angular-feather';

interface GeneratedPdfItem {
  id: string;
  name: string;
  blobUrl: string;
  iframeUrl: SafeResourceUrl;
  downloadUrl: SafeUrl;
  file: File;
  base64?: string;
}

interface GeneratedDocumentResponse {
  status: boolean;
  ok: boolean;
  documents_count: string | number;
  files: GeneratedDocumentFile[];
}

interface GeneratedDocumentFile {
  filename: string;
  content_type: string;
  content_base64: string;
}

var STATE_FLAG_PENDING = "PENDING"
var STATE_FLAG_DONE = "DONE"


@Component({
  selector: 'app-cert-desgrav',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NgxSpinnerModule,
    NotifierModule,
    ToastsContainer,
    NgxExtendedPdfViewerModule,
    FeatherModule
  ],
  templateUrl: './cert-desgrav.component.html',
  styleUrls: ['./cert-desgrav.component.scss']
})
export class CertDesgravComponent implements OnInit, OnDestroy {
  // ====== SINGLE PDF (se mantiene tal cual) ======
  pdfIframeUrl: SafeResourceUrl | null = null; // para <iframe [src]>
  pdfDownloadUrl: SafeUrl | null = null;       // para <a [href]>
  private blobUrl?: string;                    // lo revocamos para evitar fugas
  private zoomValue: number | 'page-width' = 'page-width';
  pdfSafeUrl: SafeResourceUrl | null = null;   // para <object [data]>
  file: File | null = null;
  pdfSupported = true;

  submitted = false;
  isSaving = false;
  productId: string = '';

  // ====== MULTI PDF (NUEVO) ======
  pdfs: GeneratedPdfItem[] = [];

  pdfSupportedMap: Record<string, boolean> = {};

  // Formulario Titular
  enfermedad: string | null = null;
  observacion: string = null;
  diagnosis_date: string = null;

  // Formulario Conyugue
  spouse_disease: string | null = null;
  spouse_detail_disease: string = null;
  spouse_diagnosis_date: string = null;

  // Datos
  infoCert: InsuranceConsult | null = null;
  aceptacion: boolean = false;

  today: string = '';
  todayDate: string = '';
  productSelected: any = '';
  producParam: any = '';
  iaParam: any = '';

  deviceInfo: DeviceInfo = { ip: '', userAgent: '' };

  errorNotification: boolean = false;
  errorNotificationMessage: string = 'La aceptación del seguro no fue registrada correctamente, por favor comunica este particular a tu ejecutivo/a que te acompaña en el proceso.';

  constructor(
    private route: ActivatedRoute,
    private insuranceAcceptanceService: InsuranceAcceptanceService,
    private insuranceConsultService: InsuranceConsultService,
    private sanitizer: DomSanitizer,
    public notifier: NotifierService,
    private _spinner: NgxSpinnerService,
    private readonly localStorage: CryptoJsService,
    private deviceInfoService: DeviceInfoService,
    private utilsService: UtilsService,
    private affiliationLockService: AffiliationLockService
  ) {
    


  }
  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const res = (reader.result as string) || '';
        const base64 = res.includes('base64,') ? res.split('base64,')[1] : res;
        resolve(base64);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }
  isMobile = false;
  async ngOnInit() {
    this.today = this.utilsService.getFechaEcuador();
    console.log('this.today', this.today);
    this.deviceInfo = await this.deviceInfoService.getCompleteDeviceInfo();
    console.log('Device Info:', this.deviceInfo);
    this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const id = this.route.snapshot.paramMap.get('id');
    this.iaParam = this.route.snapshot.queryParamMap.get('IA');
    this.producParam = this.route.snapshot.queryParamMap.get('product_id');
    const ruc = this.route.snapshot.queryParamMap.get('ruc');

    if (this.iaParam === 'true') {
      const tokenParam = this.route.snapshot.queryParamMap.get('token');
      this.localStorage.setItem('token', tokenParam);
      this.productSelected = this.producParam;
      if (id) this.getCertDesgrav(id);
    } else {
      this.productSelected = JSON.parse(this.localStorage.getItem('productSelected'));
      console.log('this.productSelected', this.productSelected);
      if (id) {
        this.getCertDesgrav(id);
      } else {
        console.error('ID not found in route parameters');
      }
    }

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) this.pdfSupported = false;
  }

  // ==== Consultar certificado
  async getCertDesgrav(credit_number: string) {
    try {
      this._spinner.show();

      const response = await lastValueFrom(
        this.insuranceConsultService.getInsuranceConsultByCreditNumber(credit_number)
      );
      console.log('response', response);

      if (!response || response.length === 0) {
        this.infoCert = null;
        this.aceptacion = false;
        this.clearPdf();
        this.notifier.notify('warning', 'No se encontró datos!');
        return;
      }

      this.infoCert = response[0];
      console.log('infoCert', this.infoCert);
      //activar control solo para ESTA afiliación
      this.affiliationLockService.startLock(this.infoCert.id, 'Aceptación de Seguro');
      if (this.infoCert && this.infoCert?.product_id) {
        this.productSelected = this.infoCert.product_id;
      }
      // Si ya tiene disease registrado, lo tratamos como aceptación existente

      if (this.infoCert?.disease || this.infoCert?.state_flag === STATE_FLAG_DONE) {
        this.aceptacion = true;

        const applies = this.infoCert.notification_applicable;
        const status = this.infoCert.notification_status;

        this.errorNotification =
          applies && status !== 'not_applicable' && status !== 'sent';


        return;
      } else {
        this.aceptacion = false;
      }



      await this.generatePDF(this.infoCert);
    } catch (error) {
      console.error(error);
      this.notifier.notify('error', 'Ocurrió un error al consultar el seguro');
    } finally {
      this._spinner.hide();
    }
  }

  // ==== Generar PDF(s) según proyecto
  async generatePDF(data: any): Promise<void> {
    if (!data?.id) {
      this.submitted = false;
      this.notifier.notify('warning', 'No se encontró el identificador del seguro.');
      return;
    }

    this.localStorage.setItem('projectId', data.project_id);
    this.productId = this.productSelected?.id || this.productSelected;

    try {
      const response = await firstValueFrom(
        this.insuranceConsultService.getGeneratedDocuments(data.id)
      ) as GeneratedDocumentResponse;

      await this.loadGeneratedDocuments(response);
    } catch (error: any) {
      this.clearPdf();
      this.submitted = false;
      const detail = error?.error?.detail;
      const message = typeof detail === 'string'
        ? detail
        : error?.error?.message || 'No se pudieron generar los certificados.';
      this.notifier.notify('error', message);
      console.error('Error al generar los certificados:', error);
    }
  }

  private async loadGeneratedDocuments(response: GeneratedDocumentResponse): Promise<void> {
    const files = Array.isArray(response?.files) ? response.files : [];

    this.clearPdf();
    if (!response?.ok || !files.length) {
      this.submitted = false;
      this.notifier.notify('warning', 'No se generaron certificados para mostrar.');
      return;
    }

    for (const [index, document] of files.entries()) {
      if (!document?.content_base64) continue;

      try {
        const base64 = this.normalizedBase64(document.content_base64);
        const blob = this.base64ToBlob(base64, document.content_type || 'application/pdf');
        const filename = document.filename || `certificado-${index + 1}.pdf`;
        const id = `${index}-${filename}`;
        const item = await this.buildPdfUrlsForItemAsync(blob, filename, id);
        item.base64 = base64;
        this.pdfs.push(item);
        this.pdfSupportedMap[id] = true;
      } catch (error) {
        console.error('No se pudo procesar el certificado recibido:', document.filename, error);
      }
    }

    if (!this.pdfs.length) {
      this.submitted = false;
      this.notifier.notify('warning', 'Los certificados recibidos no contienen información válida.');
      return;
    }

    const first = this.pdfs[0];
    this.activePdfId = first.id;
    this.pdfIframeUrl = first.iframeUrl;
    this.pdfDownloadUrl = first.downloadUrl;
    this.file = first.file;
    this.pdfSupported = true;
    this.submitted = true;
  }

  private base64ToBlob(base64: string, contentType: string): Blob {
    const binary = atob(base64.replace(/\s/g, ''));
    const bytes = new Uint8Array(binary.length);

    for (let index = 0; index < binary.length; index++) {
      bytes[index] = binary.charCodeAt(index);
    }

    return new Blob([bytes], { type: contentType });
  }

  // ==== limpiar todo
  private clearPdf() {
    this.pdfSafeUrl = null;
    this.pdfIframeUrl = null;
    this.pdfDownloadUrl = null;
    this.singleBase64 = null;
    this.file = null;
    if (this.blobUrl) {
      URL.revokeObjectURL(this.blobUrl);
      this.blobUrl = undefined;
    }
    // limpiar multi
    this.revokeAllMultiBlobUrls();
    this.pdfs = [];
    this.activePdfId = null;
    this.pdfSupportedMap = {};
  }

  onPdfError() {
    this.pdfSupported = false;
  }

  // ===== SINGLE ===== reconstruye la URL con zoom/hints
  private rebuildPdfIframeUrl(): void {
    if (!this.blobUrl) { this.pdfIframeUrl = null; return; }
    const zoomFrag = (typeof this.zoomValue === 'number')
      ? `#zoom=${this.zoomValue}`
      : '#zoom=page-width';
    const hints = `${this.blobUrl}${zoomFrag}&view=FitH&pagemode=none`;
    this.pdfIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(hints);
    this.pdfDownloadUrl = this.sanitizer.bypassSecurityTrustUrl(this.blobUrl);
  }

  singleBase64: string | null = null;

  ngOnDestroy(): void {
    if (this.blobUrl) URL.revokeObjectURL(this.blobUrl);
    this.revokeAllMultiBlobUrls();
    this.affiliationLockService.stopLock();
  }

  private async buildPdfUrlsForItemAsync(blob: Blob, name: string, id: string): Promise<GeneratedPdfItem> {
    const blobUrl = URL.createObjectURL(blob);
    const zoomFrag = (typeof this.zoomValue === 'number') ? `#zoom=${this.zoomValue}` : '#zoom=page-width';
    const hints = `${blobUrl}${zoomFrag}&view=FitH&pagemode=none`;

    const iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(hints);
    const downloadUrl = this.sanitizer.bypassSecurityTrustUrl(blobUrl);
    const filename = name.toLowerCase().endsWith('.pdf') ? name : `${name}.pdf`;
    const file = new File([blob], filename, { type: 'application/pdf' });
    const base64 = await this.blobToBase64(blob);

    return { id, name, blobUrl, iframeUrl, downloadUrl, file, base64 };
  }
  private revokeAllMultiBlobUrls(): void {
    for (const p of this.pdfs) {
      if (p.blobUrl) URL.revokeObjectURL(p.blobUrl);
    }
  }

  activePdfId: string | null = null;
  get activePdf() { return this.pdfs?.find(p => p.id === this.activePdfId) ?? null; }

  setActivePdf(id: string) {
    this.activePdfId = id;
  }


  onPdfErrorMulti(id: string | null): void {
    if (!id) return;
    this.pdfSupportedMap[id] = false;
  }

  onPdfLoadMulti(id: string | null): void {
    if (!id) return;
    this.pdfSupportedMap[id] = true;
  }

  // ==== Form helpers
  items: any = { value: [], valid: true };
  addItem(newItem: any) {
    this.items = newItem;
  }

  onEnfermedadChange(tipo: string) {
    if (tipo === 'titular') {
      if (this.enfermedad === 'N') {
        this.observacion = '';
        this.diagnosis_date = null;
      }
    } else {
      if (this.spouse_disease === 'N') {
        this.spouse_detail_disease = '';
        this.spouse_diagnosis_date = null;
      }
    }
  }

  // ==== Guardar + firmar
  async saveandsign() {
    if (this.isSaving) return;
    this.isSaving = true;

    try {
      if (this.enfermedad === null) {
        this.notifier.notify('warning', 'Seleccione si tiene enfermedades(Titular)');
        return;
      }

      this.infoCert.disease = this.enfermedad;
      this.infoCert.detail_disease = this.observacion;
      this.infoCert.diagnosis_date = this.diagnosis_date;

      if (this.enfermedad === 'S' && !this.observacion) {
        this.notifier.notify('warning', 'Ingrese la descripción de la enfermedad(Titular)!');
        return;
      }
      if (this.enfermedad === 'S' && !this.diagnosis_date) {
        this.notifier.notify('warning', 'Ingrese la fecha de diagnóstico(Titular)!');
        return;
      }

      // Conyugue
      if (this.infoCert.spouse_identification_number) {
        this.infoCert.spouse_disease = this.spouse_disease;
        this.infoCert.spouse_detail_disease = this.spouse_detail_disease;
        this.infoCert.spouse_diagnosis_date = this.spouse_diagnosis_date;

        if (this.spouse_disease === 'S' && !this.spouse_detail_disease) {
          this.notifier.notify('warning', 'Ingrese la descripción de la enfermedad(Conyugue)!');
          return;
        }
        if (this.spouse_disease === 'S' && !this.spouse_diagnosis_date) {
          this.notifier.notify('warning', 'Ingrese la fecha de diagnóstico(Conyugue)!');
          return;
        }
      }

      // Regenerar PDF por si cambió algo (mantiene tu flujo)
      await this.generatePDF(this.infoCert);
      if (!this.submitted || !this.pdfs.length) return;

      const fechaHoraAutoriza = this.utilsService.getFechaHoraISO();
      const formData = new FormData();
      formData.append('Identificacion', this.infoCert.identification_number);
      formData.append('NumeroCredito', this.infoCert.credit_number);
      // Titular
      formData.append('Enfermedad', this.infoCert.disease);
      formData.append('Observacion', this.infoCert.detail_disease);
      formData.append('diagnosis_date', this.infoCert.diagnosis_date);

      formData.append('fechaHoraAutoriza', fechaHoraAutoriza);
      formData.append('ipClienteAutoriza', this.deviceInfo.ip || '');
      formData.append('dispositivoClienteAutoriza', this.deviceInfo.userAgent || '');
      formData.append('product_id', this.productId);

      // Cónyuge (opcionales)
      if (this.infoCert.spouse_disease) formData.append('spouse_disease', this.infoCert.spouse_disease);
      if (this.infoCert.spouse_detail_disease) formData.append('spouse_detail_disease', this.infoCert.spouse_detail_disease);
      if (this.infoCert.spouse_diagnosis_date) formData.append('spouse_diagnosis_date', this.infoCert.spouse_diagnosis_date);

      formData.append('ProjectCooperative', this.infoCert.project_id);

      // Si hay múltiples PDFs generados, envía todos bajo la misma clave 'file'.
      if (this.pdfs && this.pdfs.length > 0) {
        for (const p of this.pdfs) {
          formData.append('file', p.file, p.file.name);
        }
      } else if (this.file) {
        formData.append('file', this.file, this.file.name);
      }

      this._spinner.show();
      const response = await firstValueFrom(this.insuranceAcceptanceService.postAceptoSeguro(formData));
      localStorage.removeItem('tipo_seguro');
      if (response) {
        console.log('response', response);

        this.aceptacion = true;
        this.notifier.notify('success', 'Aceptación registrada.');
        if (!response.Respuesta) {
          this.errorNotification = true;
        }
      }
    } catch (error) {
      console.error(error);
      this.notifier.notify('error', 'No se pudo registrar la aceptación');
    } finally {
      this.isSaving = false;
      this._spinner.hide();
    }
  }


  trackById = (_: number, p: { id: string }) => p.id;
  normalizedBase64(b64: string): string {
    if (!b64) return '';
    const trimmed = b64.trim();
    return trimmed.replace(/^data:[^;]+;base64,/, '');
  }
}
